import { render, staticRenderFns } from "./ParametreSociete.vue?vue&type=template&id=ffd8c984"
import script from "./ParametreSociete.vue?vue&type=script&lang=js"
export * from "./ParametreSociete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports